import {BaseComponent} from '../../../shared/components/base.component';
import {Component, OnInit} from '@angular/core';
import {Notification} from '../../../shared/model/notification';
import {NotificationsService} from '../../../shared/service/notifications.service';
import {ActivatedRoute, Router} from '@angular/router';
import {IssueNotificationStatus} from '../../../shared/enums/enums';
import {tap} from 'rxjs/internal/operators';

@Component({
  selector: 'app-dashboard-notifications-card',
  templateUrl: './dashboard-notifications-card.component.html',
  styleUrls: ['./dashboard-notifications-card.component.scss'],
})
export class DashboardNotificationsCardComponent extends BaseComponent implements OnInit {

  public list: Notification[];
  public isLoading: boolean;
  public areLatestNotificationsSelected: boolean;

  constructor(private notificationsService: NotificationsService, private router: Router, private route: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    this.init();
    this.getOpenNotifications();
  }

  public init() {
    this.list = [];
    this.areLatestNotificationsSelected = false;
  }

  public goToNotificationDetailsPage(notification: Notification) {
    if (this.areLatestNotificationsSelected) {
      this.router.navigate(['notifications', notification.id],
        {relativeTo: this.route.parent, queryParams: {id: notification.id}});
    } else {
      this.router.navigate(
        ['notifications', notification.id],
        {relativeTo: this.route.parent, queryParams: {id: notification.id, status: [IssueNotificationStatus.OPEN]}}
        );
    }
  }

  public goToNotificationsPage() {
    if (this.areLatestNotificationsSelected) {
      this.router.navigate(['notifications'], {relativeTo: this.route.parent});
    } else {
      this.router.navigate(['notifications'], {relativeTo: this.route.parent, queryParams: {status: [IssueNotificationStatus.OPEN]}});
    }
  }

  public getLatestNotifications() {
    this.isLoading = true;
    this.notificationsService.getLatestNotifications()
      .pipe(
        tap(() => this.isLoading = false)
      )
      .subscribe(r => this.list = r.currentElements);
  }

  public getOpenNotifications() {
    this.isLoading = true;
    this.notificationsService.
    getOpenNotifications()
      .pipe(
        tap(() => this.isLoading = false)
      )
      .subscribe(r => this.list = r.currentElements);
  }

  public isListEmpty(): boolean {
    return !this.list.length;
  }

  public showLatestNotifications() {
    this.areLatestNotificationsSelected = true;
    this.getLatestNotifications();
  }

  public showOpenNotifications() {
    this.areLatestNotificationsSelected = false;
    this.getOpenNotifications();
  }
}
